document.addEventListener('DOMContentLoaded', () => {
	
  setTimeout(() => {
    // Select all the target elements
    const ratingElements = document.querySelectorAll('.grid-product .grid-product__meta .loox-rating');

    ratingElements.forEach(el => {
      const rating = el.getAttribute('data-rating') || '0';
      const ratersAttr = el.getAttribute('data-raters');
      
      // Check if data-raters exists, is not 'none', and is greater than 0
      const isNoneOrZero = !ratersAttr || ratersAttr.toLowerCase() === 'none' || parseInt(ratersAttr, 10) <= 0;

      if (!isNoneOrZero) {
        // If raters are more than 0, update the aria-label
        const ratersCount = parseInt(ratersAttr, 10);
        el.setAttribute('aria-label', `${rating} of 5 star rating from ${ratersCount} reviews.`);
      } else {
        // If raters are none or zero, remove aria-label and role
        el.removeAttribute('aria-label');
        el.removeAttribute('role');
      }
    });
  }, 3000);
  
  $(document).on('click', '.faq-question', function () {
    const $thisButton = $(this);
    const isCurrentlyExpanded = $thisButton.attr('aria-expanded') === 'true';
    $('.faq-question')
      .not($thisButton)
      .attr('aria-expanded', 'false');
    $('.faq-answer')
      .not(getAnswerPanel($thisButton))
      .css('display', 'none');
    if (isCurrentlyExpanded) {
      $thisButton.attr('aria-expanded', 'false');
      getAnswerPanel($thisButton).css('display', 'none');
    } else {
      $thisButton.attr('aria-expanded', 'true');
      getAnswerPanel($thisButton).css('display', 'block');
    }
  });
  function getAnswerPanel($button) {
    const targetId = $button.attr('aria-controls');
    if (targetId) {
      return $('#' + targetId);
    }
    return $button.closest('.faq-item').find('.faq-answer');
  }
  
  const injectDisclaimerSVG = () => {
    const disclaimerLinks = document.querySelectorAll(
      'p[data-spam-detection-disclaimer] a'
    );

    if (disclaimerLinks.length === 0) return;

    const svgHTML = `<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none"><path d="M12 4C11.4477 4 11 3.55228 11 3C11 2.44772 11.4477 2 12 2L20 2C21.1046 2 22 2.89543 22 4V12C22 12.5523 21.5523 13 21 13C20.4477 13 20 12.5523 20 12V5.39343L3.72798 21.6655C3.33746 22.056 2.70429 22.056 2.31377 21.6655C1.92324 21.2749 1.92324 20.6418 2.31377 20.2512L18.565 4L12 4Z" fill="#197DAE"/></svg>`;

    disclaimerLinks.forEach((link) => {
      // Avoid duplicate injections if script runs multiple times
      if (!link.classList.contains('blue-link')) {
        link.classList.add('blue-link');
        link.insertAdjacentHTML('beforeend', svgHTML);
      }
    });
  };

  const injectBreadcrumbSVG = () => {
    const breadcrumbLinks = document.querySelectorAll('nav.breadcrumb a');

    if (breadcrumbLinks.length === 0) return;

    const svgHTML = `<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none"><path d="M12 4C11.4477 4 11 3.55228 11 3C11 2.44772 11.4477 2 12 2L20 2C21.1046 2 22 2.89543 22 4V12C22 12.5523 21.5523 13 21 13C20.4477 13 20 12.5523 20 12V5.39343L3.72798 21.6655C3.33746 22.056 2.70429 22.056 2.31377 21.6655C1.92324 21.2749 1.92324 20.6418 2.31377 20.2512L18.565 4L12 4Z" fill="#197DAE"/></svg>`;

    breadcrumbLinks.forEach((link) => {
      // Avoid duplicate injections if script runs multiple times
      if (!link.classList.contains('blue-link')) {
        link.classList.add('blue-link');
        link.insertAdjacentHTML('beforeend', svgHTML);
      }
    });
  };

  const injectPredictiveSearchSVG = () => {
    const predictiveSearchLinks = document.querySelectorAll('#predictive-search a');

    if (predictiveSearchLinks.length === 0) return;

    const svgHTML = `<span aria-hidden="true">›</span>`;

    predictiveSearchLinks.forEach((link) => {
      // Avoid duplicate injections if script runs multiple times
      if (!link.classList.contains('blue-link')) {
        link.classList.add('blue-link');
        link.insertAdjacentHTML('beforeend', svgHTML);
      }
    });
  };

  const removeMenuRoles = () => {
    // Selects the UL and all descendant elements inside it that have a role attribute
    const elementsWithRole = document.querySelectorAll(
      '.header-item.header-item--navigation ul li'
    );

    elementsWithRole.forEach((el) => {
        el.setAttribute('aria-expanded','false');
    });
  };

  const setupSubmenuToggles = () => {
    // Find links that have a <ul> element as an immediate sibling
    const menuLinksWithSubmenus = document.querySelectorAll(
      '.header-item.header-item--navigation a:has(+ ul)'
    );

    menuLinksWithSubmenus.forEach((link) => {
      // Prevent attaching duplicate event listeners
      if (link.dataset.submenuInitialized) return;
      link.dataset.submenuInitialized = 'true';

      // Initialize aria-expanded if not already present
      if (!link.hasAttribute('aria-expanded')) {
        link.setAttribute('aria-expanded', 'false');
      }

      // Handle Click event
      link.addEventListener('click', (e) => {
        const isExpanded = link.getAttribute('aria-expanded') === 'true';
        link.setAttribute('aria-expanded', !isExpanded);
      });
    });
  };

  // Global listener for closing submenus with the Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const openSubmenus = document.querySelectorAll(
        '.header-item.header-item--navigation a[aria-expanded="true"]'
      );

      openSubmenus.forEach((link) => {
        link.setAttribute('aria-expanded', 'false');
      });
    }
  });

  // Trap focus inside the active predictive search
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;

    const container = e.target.closest('predictive-search.is-active');
    if (!container) return;

    // Get focusable elements on every Tab to include ajax-loaded results
    const focusable = Array.from(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((el) => el.getClientRects().length > 0);

    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  // Make blog search dropdown results reachable by keyboard
  const setupBlogSearchResults = () => {
    const resultItems = document.querySelectorAll('#search-results .result-item');

    resultItems.forEach((item) => {
      // Avoid duplicate setup if script runs multiple times
      if (item.hasAttribute('tabindex')) return;

      item.setAttribute('tabindex', '0');
      item.setAttribute('role', 'link');

      // Results open in a new tab via window.open - sections/blog-search.liquid
      const title = item.querySelector('span');
      if (title) {
        title.insertAdjacentHTML('beforeend', '<span class="sr-only">, opens in a new tab</span>');
      }

      item.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          item.click();
        }
      });
    });

    
    const gridLinks = document.querySelectorAll('#search-grid a[target="_blank"]');

    gridLinks.forEach((link) => {
      // Avoid duplicate injections if script runs multiple times
      if (link.querySelector('.sr-only')) return;

      link.insertAdjacentHTML('beforeend', '<span class="sr-only">, opens in a new tab</span>');
    });
  };

  // Close the blog search dropdown with Escape and return focus to the input
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;

    const container = e.target.closest('.search-container');
    const results = container && container.querySelector('#search-results');
    if (!results || results.style.display !== 'block') return;

    results.style.display = 'none';
    container.querySelector('#blog-search-input').focus();
  });

  // Trap focus inside the blog search while its results dropdown is open
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;

    const container = e.target.closest('.search-container');
    const results = container && container.querySelector('#search-results');
    if (!results || results.style.display !== 'block') return;

    // Get focusable elements on every Tab to include ajax-loaded results
    const focusable = Array.from(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((el) => el.getClientRects().length > 0);

    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
  
  document.addEventListener('click', (event) => {
  // Check if the clicked element or its closest ancestor matches the selector
  const removeBtn = event.target.closest('.tag--remove .btn');
  if (!removeBtn) return;

  // 1. Get the text content from span.filter-label inside the button
  const labelSpan = removeBtn.querySelector('span.filter-label');
  
  // Uses span text if found; falls back to full button text if span is missing
  const tagText = labelSpan 
    ? labelSpan.textContent.trim() 
    : removeBtn.textContent.trim();

  // 2. Find or create an aria-live region
  let liveRegion = document.getElementById('a11y-filter-announcer');

  if (!liveRegion) {
    
    liveRegion = document.createElement('div');
    liveRegion.id = 'a11y-filter-announcer';
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.setAttribute('aria-atomic', 'true');
    
    // Visually hide the region
    Object.assign(liveRegion.style, {
      position: 'absolute',
      width: '1px',
      height: '1px',
      padding: '0',
      margin: '-1px',
      overflow: 'hidden',
      clip: 'rect(0, 0, 0, 0)',
      whiteSpace: 'nowrap',
      border: '0'
    });

    document.body.appendChild(liveRegion);
    console.log('DEBUG: Live region element successfully created and appended to body.');
  } else {
    console.log('DEBUG: Existing live region found in DOM.');
  }

  // Update text content for screen reader announcement
  liveRegion.textContent = '';
  
  setTimeout(() => {
    const announcement = `${tagText} is removed.`;
    liveRegion.textContent = announcement;
   
  }, 50);
});

  // Screen reader announcement of product count on filter/sort change
  const setupCollectionCountAnnouncer = () => {
    if (!document.getElementById('CollectionAjaxContent')) return;

    let announcer = document.getElementById('CollectionCountAnnouncer');
    if (!announcer) {
      announcer = document.createElement('div');
      announcer.id = 'CollectionCountAnnouncer';
      announcer.className = 'sr-only';
      announcer.setAttribute('role', 'status');
      document.body.appendChild(announcer);
    }

    let announceTimer;
    document.addEventListener('collection:reloaded', () => {
      const countEl = document.querySelector('.collection-filter__item--count');
      const text = countEl ? countEl.textContent.trim() : '';
      if (!text) return;

      // Clear first so an unchanged count is still re-announced
      announcer.textContent = '';
      clearTimeout(announceTimer);
      announceTimer = setTimeout(() => {
        announcer.textContent = text;
      }, 150);
    });
  };

  setupCollectionCountAnnouncer();

  // Move focus to the newsletter success message after the page reloads
  const focusNewsletterSuccess = () => {
    // Get the submitted form from the URL hash (e.g. #newsletter-footer)
    const submittedForm = window.location.hash
      ? document.getElementById(window.location.hash.slice(1))
      : null;

    const message =
      (submittedForm && submittedForm.querySelector('.note--success')) ||
      document.querySelector('form .note--success');
    if (!message) return;

    message.setAttribute('tabindex', '-1');

    setTimeout(() => {
      message.focus();
    }, 500);
  };

  
  // Replace comment form validation popups
  const setupCommentFormValidation = () => {
    const author = document.getElementById('CommentAuthor');
    const form = author && author.closest('form');
    if (!form || form.dataset.validationReady) return;
    form.dataset.validationReady = 'true';

    const fields = [
      {
        input: author,
        validate: (value) => (value ? '' : 'Name is required.'),
      },
      {
        input: document.getElementById('CommentEmail'),
        validate: (value) => {
          if (!value) return 'Email is required.';
          if (!/^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/.test(value)) {
            return 'Enter a valid email address, for example name@domain.com.';
          }
          return '';
        },
      },
      {
        input: document.getElementById('CommentBody'),
        validate: (value) => (value ? '' : 'Message is required.'),
      },
    ].filter((field) => field.input);

    // Disable browser popups; keep required for screen readers
    form.setAttribute('novalidate', '');

    const showError = (input, message) => {
      const errorId = `${input.id}-error`;
      let error = document.getElementById(errorId);

      if (!message) {
        if (error) error.remove();
        input.removeAttribute('aria-invalid');
        input.removeAttribute('aria-describedby');
        input.classList.remove('error', 'has-field-error');
        return;
      }

      if (!error) {
        error = document.createElement('p');
        error.id = errorId;
        error.className = 'field-error';
        input.insertAdjacentElement('afterend', error);
      }

      error.textContent = message;
      input.setAttribute('aria-invalid', 'true');
      input.setAttribute('aria-describedby', errorId);
      input.classList.add('error', 'has-field-error');
    };

    const validateField = (field) => {
      const message = field.validate(field.input.value.trim());
      showError(field.input, message);
      return !message;
    };

    // Capture phase stops invalid submits before hCaptcha runs
    form.addEventListener(
      'submit',
      (e) => {
        const invalidFields = fields.filter((field) => !validateField(field));
        if (invalidFields.length === 0) return;

        e.preventDefault();
        e.stopImmediatePropagation();
        invalidFields[0].input.focus();
      },
      true
    );

    // Re-validate fields with errors as the user types
    fields.forEach((field) => {
      field.input.addEventListener('input', () => {
        if (field.input.getAttribute('aria-invalid') === 'true') validateField(field);
      });
    });
  };

  // Run immediately on DOMContentLoaded
  if (typeof injectCSStoCartDrawer === 'function') injectCSStoCartDrawer();
  injectDisclaimerSVG();
  injectBreadcrumbSVG();
  injectPredictiveSearchSVG();
  removeMenuRoles();
  setupSubmenuToggles();
  setupBlogSearchResults();
  focusNewsletterSuccess();
  setupCommentFormValidation();

  // Observe DOM additions and attribute changes using MutationObserver
  const observer = new MutationObserver(() => {
    if (typeof injectCSStoCartDrawer === 'function') injectCSStoCartDrawer();
    injectDisclaimerSVG();
    injectBreadcrumbSVG();
    injectPredictiveSearchSVG();
    removeMenuRoles();
    setupSubmenuToggles();
    setupBlogSearchResults();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['role'],
  });
});

// Replace newsletter form validation popups
const setupNewsletterValidation = () => {
  const input = document.querySelector('input[name="contact[email]"]');
  const form = input && input.closest('form');

  if (!form || form.dataset.validationReady) return;

  form.dataset.validationReady = 'true';

  const fields = [
    {
      input: input,
      validate: (value) => {
        if (!value) return 'Email is required.';
        if (!/^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/.test(value)) {
          return 'Enter a valid email address, for example name@domain.com.';
        }
        return '';
      },
    },
  ].filter((field) => field.input);

  // Disable browser popups; keep required for screen readers
  form.setAttribute('novalidate', '');

  const showError = (input, message) => {
    const errorId = `${input.id}-error`;
    let error = document.getElementById(errorId);

    if (!message) {
      if (error) error.remove();
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-describedby');
      input.classList.remove('error', 'has-field-error');
      return;
    }

    if (!error) {
      error = document.createElement('p');
      error.id = errorId;
      error.className = 'field-error';

      const buttonContainer = input.closest('.newsletter__input-group')
        .querySelector('.input-group-btn');

      buttonContainer.insertAdjacentElement('afterend', error);
    }

    error.textContent = message;
    input.setAttribute('aria-invalid', 'true');
    input.setAttribute('aria-describedby', errorId);
    input.classList.add('error', 'has-field-error');
  };

  const validateField = (field) => {
    const message = field.validate(field.input.value.trim());
    showError(field.input, message);
    return !message;
  };

  // Capture phase stops invalid submits before other handlers
  form.addEventListener(
    'submit',
    (e) => {
      const invalidFields = fields.filter((field) => !validateField(field));

      if (invalidFields.length === 0) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      invalidFields[0].input.focus();
    },
    true
  );

  // Re-validate fields with errors as the user types
  fields.forEach((field) => {
    field.input.addEventListener('input', () => {
      if (field.input.getAttribute('aria-invalid') === 'true') {
        validateField(field);
      }
    });
  });
};

setupNewsletterValidation();

// Replace footer newsletter form validation popups
const setupFooterNewsletterValidation = () => {
  const input = document.querySelector('#Email-footer2');
  const form = input && input.closest('form');

  if (!form || form.dataset.validationReady) return;

  form.dataset.validationReady = 'true';
  form.setAttribute('novalidate', '');

  const showError = (message) => {
    const errorId = `${input.id}-error`;
    let error = document.getElementById(errorId);

    if (!message) {
      if (error) error.remove();
      input.removeAttribute('aria-describedby');
      return;
    }

    if (!error) {
      error = document.createElement('p');
      error.id = errorId;
      error.className = 'field-error';

      input.closest('.footer__newsletter').insertAdjacentElement('afterend', error);
    }

    error.textContent = message;
    input.setAttribute('aria-describedby', errorId);
  };

  const validateField = () => {
    const value = input.value.trim();

    if (!value) {
      showError('Email is required.');
      return false;
    }

    if (
      !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/.test(value)
    ) {
      showError('Enter a valid email address, for example name@domain.com.');
      return false;
    }

    showError('');
    return true;
  };

  form.addEventListener(
    'submit',
    (e) => {
      if (validateField()) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      input.focus();
    },
    true
  );

  // Re-validate after an error appears, as the user types
  input.addEventListener('input', () => {
    if (document.getElementById(`${input.id}-error`)) {
      validateField();
    }
  });
};

setupFooterNewsletterValidation();

    // 1. Check and select all matching elements
    const tooltips = document.querySelectorAll(".size-chart__standalone .tool-tip-trigger__title a");

    if (tooltips.length > 0) {
      tooltips.forEach((element, index) => {
      
        // 2. Check for 'role' attribute, add 'role="button"' if none exists
        if (!element.hasAttribute('role')) {
          element.setAttribute('role', 'button');
        }

        // 3. Check for 'aria-haspopup' attribute, add 'aria-haspopup="dialog"' if none exists
        if (!element.hasAttribute('aria-haspopup')) {
          element.setAttribute('aria-haspopup', 'dialog');
        }

        // 3. Check for 'id' attribute, add ID if none exists
    if (!element.hasAttribute('id')) {
      const uniqueId = index === 0 ? 'tooltip-trigger-btn' : `tooltip-trigger-btn-${index + 1}`;
      element.setAttribute('id', uniqueId);
    }
        const img = element.querySelector('img');
        if (img) {
          img.setAttribute('alt', '');
        }
      });
    }
  

/* fixed issue-128 to auto focus the dialog */
  const triggerBtn = document.querySelector('#tooltip-trigger-btn');
  const tooltipDialog = document.querySelector('#tooltip-dialog .tool-tip__close');

  if (triggerBtn) {
	console.log('Trigger button exists.');
  } else {
	console.log('Trigger button not found.');
  }

  if (tooltipDialog) {
	console.log('Dialog exists.');
  } else {
	console.log('Dialog not found.');
  }
    triggerBtn.addEventListener('click', () => {
      // Explicitly focus the dialog element
  	console.log('Trigger button is click.');
	setTimeout(() => {
        // Explicitly focus the dialog element
        tooltipDialog.focus();
      }, 1000);
  	console.log('Dialog is focused.');
    });

    // Focus triggerBtn when the tooltipDialog close element is clicked
if (tooltipDialog) {
    tooltipDialog.addEventListener('click', () => {
        console.log('Tooltip close clicked.');
        triggerBtn.focus();
    });
}

// Dismiss dialog and focus triggerBtn when ESC is pressed
document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
        console.log('ESC key pressed.');
        triggerBtn.focus();
        
        // Optional: If you need to explicitly hide/close the dialog container, 
        // you can add your hiding logic here, e.g.:
        // document.querySelector('#tooltip-dialog').classList.remove('is-open');
    }
});

